import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section className="hero-section">
      <div className="hero-wrapper">
        <div className="hero-content-grid">
          <div className="hero-text-column">
            <div className="hero-text-content">
              <h1 className="hero-title">
                Your trusted partner in home financing
              </h1>
              <p className="hero-description">
                We provide expert mortgage solutions for buying, refinancing, or reverse mortgages, all tailored to fit your unique financial goals and needs.
              </p>
            </div>
            <div className="hero-action-group">
              <div className="hero-input-wrapper">
                <div className="goal-select-container">
                  <select className="goal-select">
                    <option>What is your goal</option>
                    <option>Buy a home</option>
                    <option>Refinance</option>
                    <option>Reverse mortgage</option>
                  </select>
                  <svg className="select-icon" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.75 0.75L6.75 6.75L0.75 0.749999" stroke="#0578EC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <button className="get-rate-button">
                  Get your rate
                </button>
              </div>
              <p className="savings-tagline">
                We help to save more than <strong>$372M</strong> for the people to buy their first house with us.
              </p>
            </div>
          </div>
          <div className="hero-image-column">
            <img 
              className="hero-placeholder-image" 
              src="https://api.builder.io/api/v1/image/assets/TEMP/79b390f750e22a1d7718574bee3d8f5c9a68fcbf?width=1180" 
              alt="Modern home interior" 
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
